/** @jsxImportSource theme-ui */
import { Box } from "theme-ui";
import Icon from "./common/Icon";

interface StaticStarRatingProps {
  currentRating: number; // The current rating to display
}

const StaticStarRating = ({ currentRating }: StaticStarRatingProps) => {
  return (
    <Box sx={{ display: "flex", gap: 2, mt: 6 }}>
      {Array.from({ length: 10 }, (_, index) => (
        <Box key={index}>
          <Icon
            name={index < currentRating ? "star-filled" : "star"}
            size={20}
            color={index < currentRating ? "gold" : "tertiaryText"}
            sx={{
              transition: "color 0.4s",
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default StaticStarRating;